module.exports = __webpack_public_path__ + "static/media/notes-image.2223b50c.png";